"use strict";

var LoggerInstance = require("js-logger").get("EventSearchActions");

var ActionsHelper = require("../actions/ActionsHelper");

var EventSearchApi = require("../api/EventSearchApi");

var WizardConstants = require("../constants/WizardConstants");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var ApiHelper = require("../shared/ApiHelper");
var HistoryHelper = require("../shared/HistoryHelper");
var LinkMessageHelper = require("../shared/LinkMessageHelper");
var QueryStringHelper = require("../shared/QueryStringHelper");

var GridListToggleHelper = require("../designer/components/searchResults/GridListToggleHelper");

var EventSearchActions = {
	changeEventSearchType: function($selectorComponent) {
		var $searchForm = $selectorComponent.closest("[data-component='eventSearchForm']");
		var $distanceSearch = $searchForm.find("[data-component='eventDistanceSearch']");
		var $stateSearch = $searchForm.find("[data-component='eventStateSearch']");

		switch ($selectorComponent.val()) {
			case "distanceSearch":
				$stateSearch.hide();
				$distanceSearch.show();
				break;
			case "stateSearch":
				$distanceSearch.hide();
				$stateSearch.show();
				break;
			default:
				break;
		}
	},

	initializeEventSearch: function (options) {
		Dispatcher.dispatch(Object.assign({
			actionType: Constants.EVENT_SEARCH_INITIALIZE
		}, options));

		var $searchForm = $("[data-component='eventSearchForm']");
		var $selector = $searchForm.find("[data-component='eventSearchTypeSelector']");
		var $wrapper = $searchForm.find("#event-search-types-wrapper");

		// hide non selected component
		$wrapper.children().hide();
		$wrapper.children().first().show();

		// add event type selector listener
		if ($selector.length) {
			$selector.change((event) => {
				this.changeEventSearchType($(event.target));
			});
		}

		// add event form listener
		var $form = $searchForm.find("form");
		$form.off("submit.eventSearchForm");
		$form.on("submit.eventSearchForm", this._submitEventSearchForm.bind(this, options.isDesignMode));

		if (!options.isDesignMode) {
			this.layoutName = options.layoutName;

			//This is used to let the HistoryHelper know when to add state or push state.  If the id is the same as passed in last time, we replace the state.
			//	Each time a new action occurs (search, paging, etc.), the state should be pushed.
			window.lastUpdateId = 0;
			//Seeing if we have any criteria in the query string
			var query = window.location.search;
			if (query) {
				query = query.substring(1);
				var currentQueryObject = QueryStringHelper.createObjectFromQueryString(query) || {};
				_.defer(() => {
					this._updateSearchFormFields(currentQueryObject, $searchForm, (foundInput) => {
						if (foundInput) {

							var $firstSearchForm = $searchForm.first();

							if (currentQueryObject.id) {
								// We're not currently supporting server-side event search so check for criteria
								// in the parameters and perform a search post-load.
								this._performEventSearchFromSearchForm($firstSearchForm);
							}
						}
					});
				});
			}

			this.initializeEventSearchResultsButton(options.isDesignMode);
			this._initializeGridListToggle();

			window.onpopstate = (event) => {
				this._handlePopState(event);
			};
		}
	},

	initializeEventSearchResultsButton(isDesignMode, $component) {
		var $eventResult = ($component || $("body")).find("[data-component='eventSearchResults.event']");
		var $buttonElements = $eventResult.find("[data-component='eventSearchResults.button']");
		if (!isDesignMode) {
			//For the search button
			$buttonElements.off("mousedown.initializeResultsButton");
			$buttonElements.on("mousedown.initializeResultsButton", (event) => {
				this.mouseDownId = $(event.target).attr("id");
				if (event && event.which === 2) {
					//Making it so middle click does not try to allow the user to scroll
					return false;
				}
			});
			$buttonElements.off("mouseup.initializeResultsButton");
			$buttonElements.on("mouseup.initializeResultsButton", (event) => {
				var $element = $(event.target);
				if (this.mouseDownId === $element.attr("id")) {
					this._navigateToTangible(false, event);
				}
				this.mouseDownId = null;
			});
			$("body").off("mouseup.initializeResultsButton");
			$("body").on("mouseup.initializeResultsButton", () => {
				this.mouseDownId = null;
			});

			//For text and image anchor links
			var linkElements = $eventResult.find("[data-dynamic-href='register']");
			linkElements.off("click.initializeResultsButton");
			linkElements.on("click.initializeResultsButton", (event) => {
				this._navigateToTangible(false, event);
				if (event.which === 1) {
					//Only prevent default, etc. if left-clicking.  Otherwise, let it do what it normally does, most likely open a new tab.
					event.preventDefault();
					event.stopPropagation();
					return false;
				}
			});
		} else {
			$buttonElements.off("click.initializeResultsButton");
			$buttonElements.on("click.initializeResultsButton", (event) => {
				this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("register"), isDesignMode);
			});
		}
	},

	performEventSearch: function (eventSearchResultsId, pageNumber, criteria, additionalOptions) {
		var currentUpdateId = window.lastUpdateId + 1;
		additionalOptions = additionalOptions || {};
		var $eventSearchResultsComponents = $("[data-component='eventSearchResults']");
		if (eventSearchResultsId) {
			$eventSearchResultsComponents = $eventSearchResultsComponents.filter(`#${eventSearchResultsId}`);
		}
		//If there is no criteria, we might be paging, make sure we have it so that the browser history and query strings are updated appropriately.
		criteria = criteria || this._getCriteria($("[data-component='eventSearchForm']").first());

		$eventSearchResultsComponents.each((index, eventSearchResultsComponent) => {
			var $eventSearchResultsComponent = $(eventSearchResultsComponent);
			eventSearchResultsId = $eventSearchResultsComponent.attr("id");
			var additionalSearchOptions = additionalOptions[eventSearchResultsId] || {};
			var limit = $eventSearchResultsComponent.attr("data-limit");

			var offset = additionalSearchOptions.offset;
			if (!offset && pageNumber) {
				offset = limit * (pageNumber - 1);
			}

			var gridOrListSelected = $eventSearchResultsComponent.attr("data-selected-results-view");

			EventSearchApi.search(Object.assign({}, criteria, {
				id: $eventSearchResultsComponent.attr("id"),
				layoutName: this.layoutName,
				limit,
				offset
			})).done((data) => {
				// Unmount existing react components on paging after the search so we do not get that disappearing React component issue.
				$eventSearchResultsComponent.find("[data-react-component-name]").each((elementIndex, element) => {
					ReactDOM.unmountComponentAtNode(element.parentElement);
				});

				//Set new eventSearchResultsComponent
				var $data = $(data);
				$eventSearchResultsComponent.html($data);

				this.initializeEventSearchResultsButton(/*isDesignMode*/false);
				this._initializeGridListToggle(eventSearchResultsId, gridOrListSelected);

				if (!additionalOptions.doNotPushState) {
					//Saving History state if we need to do so
					var searchObject = Object.assign({
						id: eventSearchResultsId
					});

					if (pageNumber) {
						searchObject.offset = offset;
					} else {
						//We should clear the offset
						//	Undefined won't work as those are removed before the Object.assign
						//	We specifically need null because in the Object.assign it will replace the old offset, and then null values are removed before creating the query string
						searchObject.offset = null;
					}
					this._updateHistoryStateAfterSearch(criteria, searchObject, currentUpdateId);
				}

				if (eventSearchResultsId) {
					// Scroll to top of component which was paged
					var $neweventSearchResultsComponent = $(`#${eventSearchResultsId}`);
					var $window = $(window);
					var top = $neweventSearchResultsComponent.offset().top;
					var distanceToTop = top - $window.scrollTop();
					if (distanceToTop < 0 || distanceToTop > $window.height()) {
						$("html, body").animate({ scrollTop: top }, 200);
					}
				}
			}).fail((jqXHR, textStatus, errorThrown) => {
				if (jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.message === "Partial Invalid") {
					this._resetSearch(criteria);

					//Since we didn't find the right eventSearchResults Id, let's go ahead and refresh the page, removing the id query string
					window.location.reload();
				}
			});
		});
	},

	_getCountry($searchForm) {
		var $eventTypesWrapper = $searchForm.find("#event-search-types-wrapper");
		var $visibleSearchType = $eventTypesWrapper.children(":visible").first();
		var $countrySelector = $visibleSearchType.find("[data-react-component-name='CountrySelector'] select");

		if ($countrySelector.length) {
			return $countrySelector.val();
		}

		// If there's no selector on the page, return the default from the wizard.
		return window.EventSearchStore.getWizardValue(
			WizardConstants.WIZARDS.EVENT_SEARCH,
			WizardConstants.EVENT_SEARCH_FIELDS.DEFAULT_COUNTRY
		);
	},

	_getCriteria($eventSearchForm) {
		// get event search type
		var searchType = this._getEventSearchType($eventSearchForm);
		var eventTypes = $eventSearchForm.attr("data-event-search-types");

		var country = this._getCountry($eventSearchForm);
		var distance, postalCode, state;
		if (searchType === "distance") {
			distance = $eventSearchForm.find("[data-component='select'] select[name='eventDistance']").val();
			postalCode = $eventSearchForm.find("[data-component='textInput'][data-code-type='postalCode'] input").val();
		} else if (searchType === "state") {
			state = $eventSearchForm.find("[data-react-component-name='StateSelector']").find("select[name='address.state'], input[name='address.state']").val();
		}

		return {
			country,
			distance,
			eventTypes,
			postalCode,
			searchType,
			state
		};
	},

	_getEventOrReturn: function (event, isDesignModeMessage, isDesignMode) {
		return ActionsHelper.getEventOrReturn(event, isDesignMode != null ? isDesignMode : false, isDesignModeMessage, /*preventDefaultInDesignMode*/false); //coersion, because we want to check for null or undefined
	},

	_getEventSearchType($eventSearchForm) {
		var $eventTypeSelector = $eventSearchForm.find("[data-component='eventSearchTypeSelector'] select");
		if ($eventTypeSelector.length) {
			return $eventTypeSelector.val().replace("Search", "");
		}

		var $visibleEventType = $eventSearchForm
			.find("[data-component='eventSearchTypes'] #event-search-types-wrapper")
			.children(":visible")
			.first();

		return $visibleEventType.attr("data-component").replace("event", "").replace("Search", "").toLowerCase();
	},

	_handlePopState: function (event) {
		HistoryHelper.handlePopState(/*executeAction*/(currentQueryObject, additionalOptions) => {
			//Set input/selects correctly on eventSearchForm
			var $eventSearchForm = $("[data-component='eventSearchForm']");
			this._updateSearchFormFields(currentQueryObject, $eventSearchForm);

			//Search (as if the search button was clicked, just find the first form)
			var criteria = this._getCriteria($eventSearchForm);
			additionalOptions.isInitialSearch = false;

			this.performEventSearch(/*eventSearchResultsId*/null, /*pageNumber*/null, criteria, additionalOptions);

		}, /*shouldShortCircuit*/(currentQueryObject) => {
			//If there is no query string do not perform the event search
			return Object.keys(currentQueryObject).length === 0;
		});
	},

	_initializeGridListToggle: function (id, previouslySelectedView) {
		GridListToggleHelper.initializeGridListToggle(id, previouslySelectedView, "eventSearchResults", "grid-event-search-results-wrapper", "list-event-search-results-wrapper");
	},

	_navigateToTangible: function (isDesignMode, event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("register"), isDesignMode);
		if (!event) {
			return;
		}

		var $element = $(event.target);
		//Make sure we have a button or anchor
		if (!$element.is("button") && !$element.is("a")) {
			$element = $element.closest("button,a");
		}

		if (event.which === 1) {
			window.location = $element.attr("data-url") || $element.attr("href");

			event.preventDefault();
			event.stopPropagation();
		} else if (event.which === 2) {
			if ($element.is("button")) {
				//Middle-click, for buttons we need to manually open the new tab.
				window.open($element.attr("data-url") || $element.attr("href"), "_blank");
			}
		}

		//For right-click or any other click we don't want to do anything ourselves; we just want to let the context menu appear like it normally does.
	},

	// *******************************************************************
	// This is the method called when we have the context of a form submit
	// * Not called when we have history/paging
	// *******************************************************************
	_performEventSearchFromSearchForm: function ($eventSearchForm) {
		var criteria = this._getCriteria($eventSearchForm);
		this.performEventSearch(/*eventSearchResultsId*/null, /*pageNumber*/null, criteria);
	},

	// ***********************************************************
	// This is the method that's called from the form submit click
	// ***********************************************************
	_submitEventSearchForm(isDesignMode, event) {
		event = this._getEventOrReturn(event, "Event Search Form action called successfully.", isDesignMode);
		if (!event) {
			return;
		}

		var $eventSearchForm = $(event.target).closest("[data-component='eventSearchForm']");
		this._performEventSearchFromSearchForm($eventSearchForm);
	},

	_updateHistoryStateAfterSearch: function (criteria, newQueryObject, updateId) {
		HistoryHelper.updateHistoryStateAfterLoad(newQueryObject, updateId, /*afterCreateObjectLogic*/(currentQueryObject) => {
			// clear eventTypes as we pull this from attributes and don't want to show/save it.
			criteria.eventTypes = null;

			if (criteria && Object.keys(criteria)) {
				Object.assign(currentQueryObject, ApiHelper.deleteUndefinedValues(criteria));
			}
		});
	},

	_updateSearchFormFields: function (currentQueryObject, $eventSearchFormComponents, callback) {
		var foundInput = false;

		//Reset values
		$eventSearchFormComponents.find("input").prop("checked", false);
		$eventSearchFormComponents.find("input[type='text']").val("");
		$eventSearchFormComponents.find("select").val("");

		var searchType = currentQueryObject.searchType;
		if (searchType) {
			$eventSearchFormComponents
				.find("[data-component='eventSearchTypeSelector'] select")
				.val(`${searchType}Search`)
				.change();
		}

		//Populating criteria input/select fields
		Object.keys(currentQueryObject).forEach(key => {
			if (!key) {
				return;
			}

			var value = currentQueryObject[key];
			switch (key) {
				case "country":
					window.AccountActions.setSelectedCountry($eventSearchFormComponents.attr("id"), value);
					foundInput = true;
					break;
				case "distance":
					$eventSearchFormComponents.find("select[name='eventDistance']").val(value);
					foundInput = true;
					break;
				case "postalCode":
					$eventSearchFormComponents.find("input[name='postalCode']").val(value);
					foundInput = true;
					break;
				case "state":
					window.AccountActions.setSelectedState($eventSearchFormComponents.attr("id"), value);
					foundInput = true;
					break;
				case "id":
				case "offset":
				case "limit":
					// while these are search criteria, there are no inputs for them, so it's a no-op
					break;
				case "searchType":
					// We are handling this first so that the correct inputs are shown for the search type.
					break;
				default:
					// no-op, no match so set foundInput = false;
					foundInput = false;
					break;
			}
		});

		if (_.isFunction(callback)) {
			callback(foundInput);
		}
	}
};

module.exports = EventSearchActions;
